module.exports = __webpack_public_path__ + "dot_coin.svg?7544a7dc0217267f00df8da7abbf25f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/dot_coin.svg
// module id = 1150
// module chunks = 2